import { render, staticRenderFns } from "./loginForgot.vue?vue&type=template&id=6b8d8879&scoped=true&"
import script from "./loginForgot.vue?vue&type=script&lang=js&"
export * from "./loginForgot.vue?vue&type=script&lang=js&"
import style0 from "./loginForgot.vue?vue&type=style&index=0&id=6b8d8879&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8d8879",
  null
  
)

export default component.exports